import { getParameterFromURL } from "./getParameterFromUrl";

export default function getProductDuration(product) {
  let productDuration = '';
  const subscrUK = getParameterFromURL('subscrUK') === 'true';
  const subscrEU = getParameterFromURL('subscrEU') === 'true';

  const normalizeUnit = (num, unit) => {
    unit = unit.toLowerCase();

    if (unit.startsWith('w')) return `${num}week`;
    if (unit.startsWith('m')) return `${num}month`;
    if (unit.startsWith('y')) return `${num}year`;
    if (unit.startsWith('d')) {
      if (num === '7') return '1week';
      if (num === '30') return '1month';
      return `${num}day`;
    }
    return `${num}${unit}`;
  };

  const isChat = /chat/i.test(product);

  // ===== CASE 1 =====
  if (product.includes('_')) {
    const parts = product.split('_');

    if (isChat) {
      const mainPart = parts.find(p =>
        /\d+\s*(day|days|week|weeks|month|months|year|years)/i.test(p)
      );

      if (!mainPart) return '';

      const mainNum = mainPart.match(/\d+/)?.[0];
      const mainUnit = mainPart.replace(/\d+/g, '');

      if (!mainNum || !mainUnit) return '';

      const mainNorm = normalizeUnit(mainNum, mainUnit);

      if (product.includes('INTRO')) {
        const introIdx = parts.indexOf('INTRO');
        const introPart = parts[introIdx + 1];

        if (!introPart) return mainNorm;

        const introNum = introPart.match(/\d+/)?.[0];
        const introUnit = introPart.replace(/\d+/g, '');

        if (!introNum || !introUnit) return mainNorm;

        const introNorm = normalizeUnit(introNum, introUnit);
        return `${introNorm}_intro_${mainNorm}_main`;
      }

      return mainNorm;
    }

    const mainPart = parts[0];
    const mainNum = mainPart.match(/\d+/)?.[0];
    const mainUnit = mainPart.replace(/\d+/g, '');

    if (product.includes('INTRO')) {
      const introIdx = parts.indexOf('INTRO');
      const introPart = parts[introIdx + 1];

      const introNum = introPart.match(/\d+/)?.[0];
      const introUnit = introPart.replace(/\d+/g, '');

      const introNorm = normalizeUnit(introNum, introUnit);
      const mainNorm = normalizeUnit(mainNum, mainUnit);

      productDuration = `${introNorm}_intro_${mainNorm}_main`;
    } else {
      productDuration = normalizeUnit(mainNum, mainUnit);
    }

    return productDuration;
  }

  // ===== CASE 2 =====
  if (product.includes('intro')) {
    const introMatch = product.match(/(\d+)\s*([wmyd])/i);
    const mainMatch = subscrUK
      ? product.match(/then.*?(?:£[\d.]+\s*per\s*)?(\d+)?\s*([a-z]+)/i)
      : subscrEU
      ? product.match(/then.*?(?:€[\d.]+\s*per\s*)?(\d+)?\s*([a-z]+)/i)
      : product.match(/then.*?(?:\$[\d.]+\s*per\s*)?(\d+)?\s*([a-z]+)/i);

    if (introMatch && mainMatch) {
      const introNorm = normalizeUnit(introMatch[1], introMatch[2]);

      const mainNum = mainMatch[1] || '1';
      const mainUnit = mainMatch[2];
      const mainNorm = normalizeUnit(mainNum, mainUnit);

      productDuration = `${introNorm}_intro_${mainNorm}_main`;
    }
  } else {
    const match = product.match(/(\d+)\s*([wmyd])/i);
    if (match) {
      productDuration = normalizeUnit(match[1], match[2]);
    }
  }

  return productDuration;
}
